export const getErrorText = (errorArr, errorKey) => {
    if (!errorArr.length || !errorKey) return '';
    let errorText = errorArr.filter((item) => item.key === errorKey);
    if(errorText.length){
        return errorText[0].message;
    }
};
